var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { CollapseContext } from "./Collapse.context";
import { useMergeRefs } from "../../../common/useFallbackRef";
var CollapseContent = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "className", "style"]);
    var contextValue = useContext(CollapseContext);
    var collapseRef = useRef(null);
    var _b = useState("fr-collapse"), collapseClass = _b[0], setCollapseClass = _b[1];
    var _c = useState(undefined), collapseHeight = _c[0], setCollapseHeight = _c[1];
    var adjust = function () {
        if (collapseRef.current) {
            collapseRef.current.style.setProperty("--collapser", "none");
            var height = collapseRef.current.offsetHeight;
            collapseRef.current.style.setProperty("--collapser", "");
            setCollapseHeight(height);
        }
    };
    var id = contextValue === null || contextValue === void 0 ? void 0 : contextValue.id;
    var expanded = contextValue === null || contextValue === void 0 ? void 0 : contextValue.expanded;
    useEffect(function () {
        if (expanded === undefined)
            return;
        if (expanded) {
            setCollapseClass("fr-collapse fr-collapsing fr-collapse--expanded");
            adjust();
            var timer_1 = setTimeout(function () {
                setCollapseClass("fr-collapse fr-collapse--expanded");
            }, 500);
            return function () { return clearTimeout(timer_1); };
        }
        else {
            setCollapseClass("fr-collapse fr-collapsing");
            adjust();
            var timer_2 = setTimeout(function () {
                setCollapseClass("fr-collapse");
            }, 500);
            return function () { return clearTimeout(timer_2); };
        }
    }, [expanded]);
    var collapseFinalClass = [collapseClass, className].filter(Boolean).join(" ");
    var combinedRef = useMergeRefs([ref, collapseRef]);
    if (!contextValue) {
        console.warn("CollapseContext provider is needed");
        return null;
    }
    return (React.createElement("div", __assign({}, otherProps, { ref: combinedRef, className: collapseFinalClass, style: __assign(__assign({}, style), { "--collapse": collapseHeight ? "-".concat(collapseHeight, "px") : "" }), id: id }), children));
});
export default CollapseContent;
